import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/header";
import Footer from "./components/footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
// Import all page components
import AppHero from "./components/hero"; // Home
import About from "./components/about";
import Gallery from "./components/gallery";
import Programs from "./components/programs";
import Contact from "./components/contact";
import Mandatory from "./components/Mandatory/Mandatory";
import MyDocument from "./components/pdfviewer/MyDocument";
import { useState } from "react";
// import { Navbar } from 'react-bootstrap';

function App() {
  const [isPDFMode, setisPDFMode] = useState(false);

  return (
    <Router>
      <div className="App">
        {/* Show header only when not in PDF mode */}
        {!isPDFMode && (
          <header id="header">
            <Header />
          </header>
        )}
        <main>
          <Routes>
            <Route path="/" element={<AppHero />} />
            <Route path="/about" element={<About />} />
            <Route path="/mandatory" element={<Mandatory />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/academics" element={<Programs />} />
            <Route path="/contact" element={<Contact />} />

            <Route
              path="/affiliation.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="affiliation.pdf"
                  fileName="Affiliation Certificate"
                />
              }
            />
            <Route
              path="/affiltation.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="affiliation.pdf"
                  fileName="Affiliation Certificate"
                />
              }
            />
            <Route
              path="/society.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="society.pdf"
                  fileName="Society Document"
                />
              }
            />
            <Route
              path="/noc.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="noc.pdf"
                  fileName="NOC"
                />
              }
            />
            <Route
              path="/recognition.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="recognition.pdf"
                  fileName="Recognition Certificate"
                />
              }
            />
            <Route
              path="/building.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="building.pdf"
                  fileName="Building Safety Certificate"
                />
              }
            />
            <Route
              path="/firecertificate.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="firecertificate.pdf"
                  fileName="Fire Safety Certificate"
                />
              }
            />
            <Route
              path="/selfcertificate.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="selfcertificate.pdf"
                  fileName="Self Declaration Certificate"
                />
              }
            />
            <Route
              path="/waterhealth.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="waterhealth.pdf"
                  fileName="Water & Health Certificate"
                />
              }
            />
            <Route
              path="/fee.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="fee.pdf"
                  fileName="Fee Structure"
                />
              }
            />
            <Route
              path="/academic.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="academic.pdf"
                  fileName="Academic Calendar"
                />
              }
            />
            <Route
              path="/smc.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="smc.pdf"
                  fileName="School Management Committee"
                />
              }
            />
            <Route
              path="/pta.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="pta.pdf"
                  fileName="Parent Teacher Association"
                />
              }
            />
            <Route
              path="/result.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="result.pdf"
                  fileName="Previous Year Result"
                />
              }
            />
            <Route
              path="/mandatory-disclosure.pdf"
              element={
                <MyDocument
                  setisPDFMode={setisPDFMode}
                  file="mandatory-disclosure.pdf"
                  fileName="Complete Mandatory Disclosure"
                />
              }
            />

            {/* <Route path="/testimonials" element={<Testimonials />} /> */}
            {/* <Route path="/pricing" element={<Pricing />} /> */}
          </Routes>
        </main>
        {/* Show footer only when not in PDF mode */}
        {!isPDFMode && (
          <footer id="footer">
            <Footer />
          </footer>
        )}
      </div>
    </Router>
  );
}

export default App;
